import $ from "jquery";

const $filterButtons = $('.listing-type-filter-btn');
const $taxonomyCards = $('[data-elementor-type="loop-item"]');

function getParentSlug(card) {
    const $card = $(card);
    return $card.find('input[name="parent_slug"]').val();
}

function filterTaxonomyCards(selectedType) {
    let visibleCount = 0;

    $taxonomyCards.each(function() {
        const parentSlug = getParentSlug(this);

        // Show all cards if "all" is selected, otherwise filter by parent
        if (selectedType === 'all' || !selectedType || !parentSlug || parentSlug === selectedType) {
            $(this).show();
            visibleCount++;
        } else {
            $(this).hide();
        }
    });

    // Show/hide no results message
    const $noResultsMessage = $('.mi-listing-no-results-message');
    if (visibleCount === 0) {
        $noResultsMessage.show();
    } else {
        $noResultsMessage.hide();
    }
}

// Initial filter on page load
const $initialSelected = $('.listing-type-filter-btn.Button--Primary').first();
if ($initialSelected.length) {
    const initialType = $initialSelected.data('type');
    filterTaxonomyCards(initialType);
}

// Handle button clicks
$filterButtons.on('click', function(e) {
    e.preventDefault();

    const $this = $(this);

    // Update button states
    $filterButtons.removeClass('Button--Primary').addClass('Button--OutlineGray');
    $this.removeClass('Button--OutlineGray').addClass('Button--Primary');

    // Filter taxonomy cards
    const selectedType = $this.data('type');
    filterTaxonomyCards(selectedType);
});